export enum QuickFilterType {
  STATUS = 'status',
  BEHAVIOR = 'orderDestination.behaviour',
  TYPE = 'orderDestination.orderType',
  DATE = 'orderDestination.selectedDate',
}
